<template>
    <Select
        v-if="deals.length > 0"
        :value="dealId"
        :hasNone="true"
        :options="deals"
        label="Associated deal"
        name="belongs_id"
        placeholder="No associated deal"
        valueKey="id"
        @update:value="setDealId"
    >
        <template #option="{ option }">
            <div class="flex items-center">
                <div
                    :style="{
                        backgroundColor: option.getStatusColour(),
                    }"
                    class="w-2 h-2 mr-2 rounded-full shrink-0"
                />
                <div class="text-14 font-normal">
                    {{ option.getName() }} -
                    {{ $help.dp(option.quoted, 0) }}
                </div>
            </div>
        </template>
    </Select>

    <input :value="dealId != null ? dealId : contactId" name="belongs_id" type="hidden" />
    <input :value="dealId != null ? 103 : 102" name="belongs_type" type="hidden" />
</template>

<script>
import Deal from '~/models/deal'

export default {
    props: {
        modelId: { type: Number, default: null },
        modelType: { type: Number, default: null },
        contactId: { type: Number, default: null },
        deals: { type: Array, default: null },
    },

    data() {
        return {
            // deals: [],
            dealId: parseInt(this.modelType) == 103 ? parseInt(this.modelId) : null,
        }
    },

    mounted() {
        // this.getDeals();
    },

    methods: {
        getDeals() {
            this.$axios.get('/actions/contact-deals/' + this.contactId).then((res) => {
                this.deals = Deal.fill(res.deals, {
                    vue: this,
                })
            })
        },

        setDealId(id) {
            // console.log(id)
            this.dealId = id
            this.$emit('updatedDealId', id)
        },
    },
}
</script>
